import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RedirectFbService } from 'src/app/services/redirect-fb/redirect-fb.service';

@Component({
  selector: 'app-redirect-fb',
  templateUrl: './redirect-fb.component.html',
  styleUrls: ['./redirect-fb.component.css']
})
export class RedirectFbComponent implements OnInit {

  mode: string | any;

  constructor(
    private route: ActivatedRoute,
    private fbServ: RedirectFbService
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe((params: any) => {

      this.mode = params.mode;
      this.fbServ.setParams(params);

    })

  }

}
